import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectGameConfig } from "src/store/common"

import Modal from "src/components/modals/Modal"
import { foodIcon } from "src/utils/resources"

/* One stat, explained: what the number does in a battle round, with the server's own constants
   interpolated so the help can never drift from the rules it describes. Opened from any unit
   card's stat row. */

// CONSUMPTION is absent on purpose: a unit eats its own side's food, so the glyph comes from
// `foodIcon(team)` — the team the card that opened this belongs to.
const ICONS = { ATTACK: "⚔", DEFENSE: "🛡", HEALTH: "❤", SPEED: "🏃" }

const StatHelpModal = ({ stat, team }) => {
  const { t } = useTranslation()
  const gameConfig = useSelector(selectGameConfig)
  const rules = gameConfig?.rules_config || {}

  return (
    <Modal width="min(440px, 90%)" isolated={false} scope="map" top="14vh" maxHeight="70vh">
      <div className="stat-detail" style={{ padding: 22 }}>
        <h2>
          {ICONS[stat] || (stat === "CONSUMPTION" ? foodIcon(team) : "◆")}{" "}
          {t(`game.units.stats.${stat}`, { defaultValue: stat })}
        </h2>
        <p className="stat-detail-note" style={{ fontSize: "0.8125rem", lineHeight: 1.6 }}>
          {t(`game.statHelp.${stat}`, {
            subRounds: rules.SUB_ROUNDS_PER_TICK,
            decay: rules.DEFENSE_DECAY_PER_HIT,
            defaultValue: "",
          })}
        </p>
      </div>
    </Modal>
  )
}

export default StatHelpModal
